module.exports = __webpack_public_path__ + "img/01.4b2be3d9.jpg";